import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import "./App.css";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import AnnouncementBar from "./components/shared/AnnouncementBar";

import HomePage from "./pages/HomePage";
import AttendPage from "./pages/AttendPage";
import SpeakersPage from "./pages/SpeakersPage";
import ExpoPage from "./pages/ExpoPage";
import PartnerPage from "./pages/PartnerPage";
import ProgramPage from "./pages/ProgramPage";
import PlanPage from "./pages/PlanPage";
import NewsPage from "./pages/NewsPage";
import ConnectPage from "./pages/ConnectPage";
import FAQPage from "./pages/FAQPage";
import AboutPage from "./pages/AboutPage";

const BASE_TITLE = "Core AI Summit and Trade Show | Niagara Falls, Canada 2027";

const PAGE_TITLES = {
  "/": "Core AI Summit and Trade Show | Niagara Falls, Canada 2027",
  "/attend": "Attend | Core AI Summit + Tradeshow",
  "/speakers": "Speakers | Core AI Summit + Tradeshow",
  "/expo": "Expo & Trade Show | Core AI Summit + Tradeshow",
  "/partner": "Partner & Sponsor | Core AI Summit + Tradeshow",
  "/program": "Program | Core AI Summit + Tradeshow",
  "/plan": "Plan Your Visit — Niagara Falls | Core AI Summit + Tradeshow",
  "/news": "News | Core AI Summit + Tradeshow",
  "/connect": "Networking | Core AI Summit + Tradeshow",
  "/faq": "FAQ | Core AI Summit + Tradeshow",
  "/about": "About | Core AI Summit + Tradeshow",
};

function TitleUpdater() {
  const location = useLocation();
  useEffect(() => {
    document.title = PAGE_TITLES[location.pathname] || BASE_TITLE;
  }, [location.pathname]);
  return null;
}

function AppLayout({ children }) {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg)" }}>
      <div className="grain-overlay" />
      {/* Single fixed header container — fully solid, nothing bleeds through */}
      <div
        className="fixed top-0 left-0 right-0 z-[9999]"
        style={{ backgroundColor: "var(--bg)" }}
        data-testid="sticky-header"
      >
        <AnnouncementBar />
        <Navbar />
      </div>
      <main>{children}</main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "var(--surface)",
            border: "1px solid var(--border)",
            color: "var(--text)",
          },
        }}
      />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.3,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return (
    <BrowserRouter>
      <TitleUpdater />
      <AppLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/attend" element={<AttendPage />} />
          <Route path="/speakers" element={<SpeakersPage />} />
          <Route path="/expo" element={<ExpoPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/program" element={<ProgramPage />} />
          <Route path="/plan" element={<PlanPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
}

export default App;
